<template>
  <div :style="`width: 100%; ${$vuetify.breakpoint.smAndDown ? '' : 'padding-top: 50px'}`">
    <HomeDetailInfoSiteOne>
      <template #header-one>
        <!-- <h1 style="max-width: 800px; padding: 5">  </h1> -->
      </template>
      <template #text-one>
        <div style="display: flex; flex-direction: column; padding: 20px; gap: 20px">
        <HomeDetailInfoSiteTwo>
          <template #header>
            <h1 style="padding-top: 10px; font-style: normal;"> TAKT.app </h1>
          </template>
          <template #description>
            <p :style="`
            font-style: normal;
            font-size: 20px;
            ${$vuetify.breakpoint.smAndDown ? '' : ''}`">
            You want to know more about the TAKT.app or you need help with it?
            </p>
          </template>
          <template #desktop-button>
            <div :style="`display: flex; flex-direction: column;font-style: normal; align-items: center; justify-content: center; ${$vuetify.breakpoint.smAndDown ? '' : 'height: 100%'} `">
              <h3 style="padding: 10px"> app@takting.com </h3>
              <div style="display: flex; flex-direction: row; align-items: center; justify-content: center; gap: 10px;">
                <v-btn @click="$router.push({name: 'Subscribe'})"> {{$t('Home.Home.Register.Newsletter')}} </v-btn>
                <v-btn @click="$router.push({name: 'Apply'})"> {{$t('Home.Home.Register.Apply')}} </v-btn>
              </div>
            </div>
          </template>
        </HomeDetailInfoSiteTwo>
        <HomeDetailInfoSiteTwo>
          <template #header>
            <h1 style="padding-top: 10px; font-style: normal;"> TAKT.training </h1>
          </template>
          <template #description>
            <p :style="`
            font-style: normal;
            font-size: 20px;
            ${$vuetify.breakpoint.smAndDown ? '' : ''}`">
            You want to talk about TAKT.training
            </p>
          </template>
          <template #desktop-button>
            <div :style="`display: flex; flex-direction: column;font-style: normal; align-items: center; justify-content: center; ${$vuetify.breakpoint.smAndDown ? '' : 'height: 100%'} `">
              <h3 style="padding: 10px"> training@takting.com </h3>

            </div>
          </template>
        </HomeDetailInfoSiteTwo>
        <HomeDetailInfoSiteTwo>
          <template #header>
            <h1 style="padding-top: 10px; font-style: normal;"> TAKT.ing </h1>
          </template>
          <template #description>
            <p :style="`
            font-style: normal;
            font-size: 20px;
            ${$vuetify.breakpoint.smAndDown ? '' : ''}`">
            You want to get in touch with our company?
            </p>
          </template>
          <template #desktop-button>
            <div :style="`display: flex; flex-direction: column;font-style: normal; align-items: center; justify-content: center; ${$vuetify.breakpoint.smAndDown ? '' : 'height: 100%'} `">
              <h3 style="padding: 10px"> info@takting.com </h3>

            </div>
          </template>
        </HomeDetailInfoSiteTwo>
      </div>
      </template>
    </HomeDetailInfoSiteOne>

  </div>
</template>

<script>
import HomeDetailInfoSiteTwo from '@/components/Home/HomeDetailInfoSiteTwo.component.vue'
import HomeDetailInfoSiteOne from '@/components/Home/HomeDetailInfoSiteOne.component.vue'
export default {
  components: {
    HomeDetailInfoSiteTwo,
    HomeDetailInfoSiteOne
  }
}
</script>
